@layer design-system {
  .listOption {
    list-style-type: none;

    &:not(.disabled) {
      cursor: pointer;
    }

    &:not(.hasV2Styles) {
      &:global(.focused),
      &:global(.active),
      &:hover {
        color: var(--text-primary);

        [data-badge='textual'] {
          color: var(--text-primary);
          border-color: var(--border-primary);
        }
      }
    }
  }
}
